// views/how-to-play-copy.js: pure text model behind HowToPlayView.
//
// node:test never transforms JSX, so (mirroring views/networked-status.js)
// the room-dependent copy lives here as plain functions and HowToPlayView
// renders their exact strings. Unit tests drive the live room-settings
// store through these functions to prove an OPEN panel's text follows the
// room without reopening; how-to-play.spec.js covers the JSX mounting.

/**
 * @param {{ targetScore?: 7|10, stickTheDealer?: boolean }|null|undefined} settings
 * @returns {string} e.g. "10 points" (rendered inside "The first team to … wins.").
 */
export function howToPlayTargetPoints(settings) {
  return `${settings?.targetScore === 7 ? 7 : 10} points`;
}

/**
 * @param {{ targetScore?: 7|10, stickTheDealer?: boolean }|null|undefined} settings
 * @returns {string} the round-2 tail ("…, except the dealer…" vs "…, or pass.").
 */
export function howToPlayRoundTwoTail(settings) {
  return settings?.stickTheDealer === false
    ? ', or pass.'
    : ', except the dealer, who cannot pass and must call one.';
}

/**
 * @param {{ targetScore?: 7|10, stickTheDealer?: boolean }|null|undefined} settings
 * @returns {string} the stick-the-dealer paragraph (data-testid how-to-play-stick).
 */
export function howToPlayStickParagraph(settings) {
  return settings?.stickTheDealer === false
    ? 'Stick the dealer is off: if everyone passes in round 2 as well, the hand is thrown in and the deal moves on.'
    : 'Stick the dealer is on: with nowhere else to go, the dealer must call a trump in round 2.';
}
